var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"mymodal",on:{"click":_vm.clickBg}},[(_vm.isShowGuideLight)?_c('GuideLight'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }